// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore, collection, doc, setDoc, getDoc } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// CRA only injects REACT_APP_* vars. Use .env, .env.local, .env.development, or .env.production in project root.
const getEnv = (key) => {
  const v = process.env[key];
  return (v && String(v).trim() && v !== 'undefined' && !/^your[-_]?(api[-_]?key|project|sender|app)/i.test(v)) ? v : '';
};

const apiKey = getEnv('REACT_APP_FIREBASE_API_KEY');
const projectId = getEnv('REACT_APP_FIREBASE_PROJECT_ID');

if (!apiKey || !projectId) {
  throw new Error(
    'Firebase config missing. Development: use .env.development or .env.local. Production build: use .env.production or .env (project root). ' +
    'Copy .env.example to .env.production and fill in values from Firebase Console, then run npm run build again.'
  );
}

const firebaseConfig = {
  apiKey,
  authDomain: getEnv('REACT_APP_FIREBASE_AUTH_DOMAIN') || `${projectId}.firebaseapp.com`,
  databaseURL: getEnv('REACT_APP_FIREBASE_DATABASE_URL') || `https://${projectId}-default-rtdb.firebaseio.com`,
  projectId,
  storageBucket: getEnv('REACT_APP_FIREBASE_STORAGE_BUCKET') || `${projectId}.firebasestorage.app`,
  messagingSenderId: getEnv('REACT_APP_FIREBASE_MESSAGING_SENDER_ID'),
  appId: getEnv('REACT_APP_FIREBASE_APP_ID'),
  measurementId: getEnv('REACT_APP_FIREBASE_MEASUREMENT_ID')
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app); // Initialize Firestore
const auth = getAuth(app);

// Export all necessary Firebase functions and instances
export { db, auth, collection, doc, setDoc, getDoc };